import BN from 'bn.js';
import converter from '@/web3-server/utils/converter';
export default function getMaxApproval(currencyDecimals = 18) {
    const maxInt = new BN('2').pow(new BN('256')).sub(new BN('1'));
    return converter.withoutType
        .fromWei(maxInt.toString(), { decimals: currencyDecimals })
        .round()
        .toFixed();
}
